import { render, staticRenderFns } from "./UserQuota.vue?vue&type=template&id=7b74546c&scoped=true"
import script from "./UserQuota.vue?vue&type=script&lang=js"
export * from "./UserQuota.vue?vue&type=script&lang=js"
import style0 from "./UserQuota.vue?vue&type=style&index=0&id=7b74546c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b74546c",
  null
  
)

export default component.exports